<footer>
	<span>Made by <a href="https://github.com/damevin">Raphaël DAMEVIN</a></span>
</footer>

<style>
	footer {
		display: flex;
		justify-content: center;
	}
	a {
		color: #f43b86;
	}

	a:hover {
		color: #3d087b;
	}
</style>
